module.exports = __webpack_public_path__ + "img/footer.c04e3191.jpg";